module.exports = __webpack_public_path__ + "static/media/df-icon.e4ff9d76.png";